/*
 * @Author       : zxlin
 * @Date         : 2023-07-02 03:51:30
 * @LastEditors  : zxlin
 * @LastEditTime : 2024-02-07 09:44:35
 * @FilePath     : \h5-vue3-template\src\directives\um.js
 * @Description  : 埋点
 */
export default {
  mounted(el, binding) {
    let key, option = {}
    if (typeof binding.value === 'string') {
      key = binding.value
    } else {
      key = binding.value.key
      option = binding.value.option
    }
    el.addEventListener('click', function () {
      window.UMHook(key, option)
    })
  },
}